module.exports = __webpack_public_path__ + "img/maps-and-flags.2400d3aa.png";